import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { AuthCard } from '../../features/auth/components/AuthCard';
import { OAuthButtons } from '../../features/auth/components/OAuthButtons';
import { SignupForm } from '../../features/auth/components/SignupForm';
import { ensureIdentity } from '../../features/auth/useAuth';
import { PublicLayout } from '../../layouts/PublicLayout';
import { isLocale } from '../../lib/i18n';

export const Route = createFileRoute('/$lang/signup')({
  beforeLoad: async ({ context, params }) => {
    const identity = await ensureIdentity(context.queryClient);
    if (identity !== null && !identity.isGuest) {
      throw redirect({ to: '/$lang/app', params: { lang: params.lang } });
    }
  },
  component: SignupScreen,
});

function SignupScreen(): React.ReactNode {
  const { lang } = Route.useParams();
  const { t } = useTranslation();

  return (
    <PublicLayout lang={lang} focus>
      <AuthCard
        eyebrow={t('auth.signup.eyebrow')}
        title={t('auth.signup.title')}
        subtitle={t('auth.signup.subtitle')}
        image={{ face: 'star', caption: `XVII · ${t('auth.card.star')}` }}
        footer={
          <>
            {t('auth.signup.haveAccount')}{' '}
            <Link to="/$lang/login" params={{ lang }} className="text-accent underline">
              {t('auth.signup.signIn')}
            </Link>
          </>
        }
      >
        {/* The route guard has already established that lang is a Locale. */}
        <SignupForm lang={isLocale(lang) ? lang : 'en'} />
        <OAuthButtons callbackUrl={`${globalThis.location.origin}/${lang}/app`} />
      </AuthCard>
    </PublicLayout>
  );
}
